import React, {Component} from 'react'
import { Row, Col, Card, CardBody, Pagination, PaginationItem, PaginationLink} from 'reactstrap'
import WastageList from '../components/WastageList'
import { withTranslation } from 'react-i18next'



class Wastage extends Component{

	constructor(props){
    super(props);

    this.state = {
        customerLayout : "Wastage List"
        }
    }

    inventoryList = (props) =>{
    	return(
    		<Card className="card-box">
                <div className="card-header">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="title">{this.props.t('Wastage Report')}</div>
                        </div>
                    </div>
                </div>
                <CardBody>
                    <WastageList handleOrderView={this.updateLayout}/>
                </CardBody>
            </Card>
            )
    }

    

    updateLayout = (layout) =>{
        this.setState({customerLayout : layout});
    }

    getCustomerComponent(layout){

        var showLayout = '';

        switch(layout){
            case "Wastage List" : showLayout=this.inventoryList(this.props);
            break;
            default:
            showLayout = "";
        }

        return showLayout;

    }

	render(){
		let showLayout = this.getCustomerComponent(this.state.customerLayout)
		return(
			<div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        {showLayout}
                    </div>
                </div>
            </div>
			)
	}
}

export default withTranslation()(Wastage);